export const Project = {
  getFederalProjectCode(fp) {
    return +fp.project_code;
  }
};
